<template>
  <div>
    <span class="checkbox--filter">
      <input id="filter-greenkey" v-model="greenKey" type="checkbox" />
      <label for="filter-greenkey" class="checkbox--filter--label">{{
        $t("greenKeyFilter.header")
      }}</label>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    initialValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      greenKey: this.initialValue
    };
  },
  emits: ["greenKeyChanged"],
  watch: {
    greenKey: {
      handler(newValue, oldValue) {
        this.$emit("greenKeyChanged", this.greenKey);
      },
      deep: true
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
